import React from 'react';
import { PayloadStates } from '@lore/utils';
import classNames from 'classnames';
import Loader from '../../components/Loader';
import EmptyState from '../../@communityshare/ui/EmptyState';
import { NewspaperIcon } from '@heroicons/react/24/outline';

export default function Results(props) {
  const { result, row } = props;

  if (result.state === PayloadStates.FETCHING) {
    return (
      <Loader />
    );
  }

  if (result.data.length === 0) {
    return (
      <EmptyState
        icon={NewspaperIcon}
        title="There are currently no matching offers."
        subtitle="But check back later and there might be."
      />
    );
  }

  return (
    <div className={classNames(
      result._isPreviousData && 'opacity-50',
      'w-full grid grid-cols-1 gap-4'
    )}>
      {result.data.map(row)}
    </div>
  );
}
